/** @format */
'use client';
import AccountDashboard from '@/app/[locale]/(protected)/(dashboard)/ui/AccountDashboard';
import CompanyDashboard from '@/app/[locale]/(protected)/(dashboard)/ui/CompanyDashboard';
import DashboardSidebar from '@/app/[locale]/(protected)/(dashboard)/ui/DashboardSidebar';
import DocumentDashboard from '@/app/[locale]/(protected)/(dashboard)/ui/DocumentDashboard';
import useUserRoles from '@common/application/hooks/useUserRoles/useUserRoles';
import AccountSearchDashboard from '@organisms/AccountSearchDashboard';
import { AnimatePresence, motion } from 'motion/react';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import styles from './page.module.css';

export enum DashboardView {
  ACCOUNTS = 'accounts',
  DOCUMENTS = 'documents',
  COMPANY = 'company',
  SEARCH = 'search',
}

function Page({ children }: { children: React.ReactNode }) {
  const path = usePathname();
  const [view, setView] = useState(DashboardView.ACCOUNTS);
  const { isAdmin } = useUserRoles();

  const getView = () => {
    switch (view) {
      case DashboardView.ACCOUNTS:
        return <AccountDashboard />;
      case DashboardView.DOCUMENTS:
        return <DocumentDashboard />;
      case DashboardView.COMPANY:
        return isAdmin ? <CompanyDashboard /> : <AccountDashboard />;
      case DashboardView.SEARCH:
        return <AccountSearchDashboard />;
      default:
        return <AccountDashboard />;
    }
  };

  return (
    <div className={styles.wrapper}>
      {/*{children}*/}
      <DashboardSidebar view={view} setView={setView} />
      <AnimatePresence mode={'wait'}>
        <motion.div
          className={styles.content}
          key={path}
          initial={{ opacity: 0, y: -100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          {getView()}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default Page;
